import React from 'react';
import CreatableSelect from 'react-select/creatable';
import styled, { useTheme } from 'styled-components';
import { Theme } from 'styles/theme';

import useIsReadOnlyMode from '../compiler/hooks/useIsReadOnlyMode';
import { getCustomWizardSelectStyles } from '../epd-compiler-inputs/select-styles';
import SmartLabel, { TSmartLabelProps } from '../labels/SmartLabel';

type TProps = Partial<TSmartLabelProps> & {
  name: string;
  value: any;
  options: any[];
  isMulti?: boolean;
  style?: any;
  onChanged: any;
  placeholder?: string;
  disabled?: boolean;
  isClearable?: boolean;
} & any;

const WizardCreatableSelectControlledComponent: React.FunctionComponent<TProps> = ({
  label,
  options,
  tooltip,
  labelStyle,
  name,
  value,
  onChanged,
  disabled,
  style,
  required,
  isMulti,
  isClearable = true,
  ...props
}) => {
  const theme = useTheme() as Theme;
  const customSelectStyles = getCustomWizardSelectStyles(theme);

  const isReadOnly = useIsReadOnlyMode() || disabled;

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {label && (
        <SmartLabel
          label={label}
          required={required}
          labelStyle={labelStyle}
          tooltip={tooltip}
          hasValue={isMulti ? value && value.length > 0 : !!value?.value}
        />
      )}
      <StyledSelect
        options={options}
        name={name}
        value={value}
        onChange={(e: any) => {
          onChanged(name, isMulti ? e : e?.value);
        }}
        isClearable={isClearable}
        isMulti={isMulti}
        isDisabled={isReadOnly}
        styles={customSelectStyles}
        {...props}
      />
    </div>
  );
};

const StyledSelect = styled(CreatableSelect)``;

export default WizardCreatableSelectControlledComponent;
